/**
 * Shared constants and pure helpers for DateTimeInput.
 */

export type DateTimeInputSize = "sm" | "md" | "lg";

export const SIZE_CLASSES: Record<
  DateTimeInputSize,
  {
    input: string;
    paddingL: string;
    paddingRightWithIcon: string;
    icon: string;
    iconRight: string;
  }
> = {
  sm: {
    input: "py-(--input-sm-padding-y) body-xs-regular",
    paddingL: "pl-(--input-sm-padding-x)",
    paddingRightWithIcon:
      "pr-[calc(var(--input-sm-padding-x)+var(--input-sm-icon-size)+var(--input-sm-gap))]",
    icon: "size-[var(--input-sm-icon-size)]",
    iconRight: "right-(--input-sm-padding-x)",
  },
  md: {
    input: "py-(--input-md-padding-y) body-sm-regular",
    paddingL: "pl-(--input-md-padding-x)",
    paddingRightWithIcon:
      "pr-[calc(var(--input-md-padding-x)+var(--input-md-icon-size)+var(--input-md-gap))]",
    icon: "size-[var(--input-md-icon-size)]",
    iconRight: "right-(--input-md-padding-x)",
  },
  lg: {
    input: "py-(--input-lg-padding-y) body-md-regular",
    paddingL: "pl-(--input-lg-padding-x)",
    paddingRightWithIcon:
      "pr-[calc(var(--input-lg-padding-x)+var(--input-lg-icon-size)+var(--input-lg-gap))]",
    icon: "size-[var(--input-lg-icon-size)]",
    iconRight: "right-(--input-lg-padding-x)",
  },
};

function startOfDay(date: Date): Date {
  const copy = new Date(date);
  copy.setHours(0, 0, 0, 0);
  return copy;
}

/** True when the date falls outside the selectable range (date-only comparison). */
export function isDateOutOfRange(
  date: Date,
  maxDate: Date | undefined,
  minDate: Date | undefined,
): boolean {
  const day = startOfDay(date);
  if (maxDate && day > startOfDay(maxDate)) return true;
  return !!minDate && day < startOfDay(minDate);
}

export function isTodayDisabled(
  maxDate: Date | undefined,
  minDate: Date | undefined,
): boolean {
  return isDateOutOfRange(new Date(), maxDate, minDate);
}
